import React, { ReactElement } from "react";
import content from "./content";
import { useRouter } from "next/router";
import styles from "./styles.module.scss";

export default function CategoryIntro(): ReactElement {
    const { query } = useRouter();

    const item = content[query.tool as keyof typeof content];

    return (
        <section className={styles.outro}>
            <h3>{item?.title}</h3>
            <p>{item?.description}</p>
        </section>
    );
}
